import {Component, input, ChangeDetectionStrategy} from "@angular/core"
import {ThreeTemplateSceneViewerComponent} from "@app/template-editor/components/three-template-scene-viewer/three-template-scene-viewer.component"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-zoom-button",
    standalone: true,
    templateUrl: "./zoom-button.component.html",
    styleUrls: ["./zoom-button.component.scss"],
    imports: [],
})
export class ZoomButtonComponent {
    readonly $threeViewer = input.required<ThreeTemplateSceneViewerComponent>({alias: "threeViewer"})

    private zoomSession:
        | {
              accumulatedDelta: number
              animationFrameId: number | undefined //used for throttling
              pointerId: number //Only use a single pointer (e.g. mouse or pen click, ignore others)
              element: HTMLElement
          }
        | undefined = undefined

    private processZoomDelta = () => {
        if (!this.zoomSession) return
        const session = this.zoomSession
        session.animationFrameId = undefined

        const delta = session.accumulatedDelta
        session.accumulatedDelta = 0

        const absDelta = Math.abs(delta)

        const zoomStep = absDelta / 250

        if (delta < 0) this.$threeViewer().zoomIn(zoomStep)
        else this.$threeViewer().zoomOut(zoomStep)
    }

    private scheduleZoomFrame() {
        if (!this.zoomSession) return
        if (this.zoomSession.animationFrameId !== undefined) return
        this.zoomSession.animationFrameId = requestAnimationFrame(this.processZoomDelta)
    }

    private exitPointerLock() {
        if (document.pointerLockElement) {
            document.exitPointerLock()
        }
        if (this.zoomSession) {
            if (this.zoomSession.animationFrameId !== undefined) {
                cancelAnimationFrame(this.zoomSession.animationFrameId)
            }
            this.zoomSession = undefined
        }
    }

    onPointerDown(e: PointerEvent) {
        if (e.button !== 0) return

        const element = e.target as HTMLElement

        this.zoomSession = {
            accumulatedDelta: 0,
            animationFrameId: undefined,
            pointerId: e.pointerId,
            element: element,
        }

        element.requestPointerLock()
    }

    onPointerMove(e: PointerEvent) {
        const session = this.zoomSession
        if (!session || e.pointerId !== session.pointerId) return

        session.accumulatedDelta += e.movementY
        this.scheduleZoomFrame()
    }

    onPointerUp(e: PointerEvent) {
        const session = this.zoomSession
        if (!session || e.pointerId !== session.pointerId) return

        this.exitPointerLock()
    }
}
